<section class="sg-container" >
    <div class="row m-0 border-bottom p-3">
      <h1 mat-dialog-title class="mb-0 pl-2">{{dialogHeaderName}}</h1>
    </div>
    <main mat-dialog-content class="sg-dialog-content py-3">
      <form [formGroup]="supplierUserForm" novalidate autocomplete="off">
        <div class="row mx-2 border rounded" *ngIf="!data.isEditUser">
          <div class="col-12">     
            <div class="row p-2">
              <span class="material-icons-outlined pr-2 sg-supplier-management-info">info</span> 
              <span class="pt-1"> Supplier Organization needs to already have a CWS account</span>
            </div>  
          </div>
        </div>
        <div class="row pt-2" *ngIf="!data.isEditUser">
          <div class="col-3 pt-3 pr-0 sg-field-label-align">
            <label class="sg-form-field-label">
                Search
                <span class="material-icons-outlined pr-2 sg-supplier-management-info">
                  <p class="material-icons-outlined" [tooltip]="template" contentType="template"
                      [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">info</p>
                  <ng-template #template class="w-100">
                      <div class="row mx-0 w-100">
                          <div class="col-12 w-100 px-0">
                              <span> If Supplier does not exist, please log a ticket in ServiceNow. Assign ticket to assignment group "ESC-IAM" team to add Supplier to IAM lookup.
                              </span>
                          </div>
                      </div>
                  </ng-template>
              </span>
            <span class="sg-form-field-required-marker ml-1">*</span></label>
          </div>        
          <div class="col-9 pt-1">
            <mat-form-field appearance="outline" class="w-100 input-value-uppercase">
              <input matInput formControlName="search" type="text" placeholder="Search by Supplier Code" aria-label="Name" [matAutocomplete]="auto" maxlength="30">
            </mat-form-field>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="getOptionText">
              <mat-option *ngFor="let user of searchResults?.resources" [value]="user">
                {{user.catafltnorgcode + "-" + user.o}}
              </mat-option>
            </mat-autocomplete>
            <mat-error class="error-font-size" *ngIf="supplierUserForm.controls['search'].hasError('selSpeChar')">
              Special characters or only empty value aren't allowed in this field.
            </mat-error>
            <mat-error class="error-font-size" *ngIf="supplierUserForm.controls['search'].hasError('minLength')">
              Must input at least 5 characters to Search
            </mat-error>
            <mat-error class="error-font-size" *ngIf="supplierUserForm.controls['search'].hasError('noRecord')">
              No Matching Record Found.
            </mat-error>
            <mat-error class="error-font-size" *ngIf="supplierUserForm.controls['search'].hasError('inValidCatlogin')">
              The selected user has invalid CatloginId.
            </mat-error>
            <mat-error class="error-font-size" *ngIf="supplierUserForm.controls['search'].hasError('inUserExists')">
              The selected user has already been added.
            </mat-error>
          </div>        
        </div>
        <mat-divider *ngIf="!data.isEditUser"></mat-divider>
        <div class="row pt-3">
          <div class="col-3 pt-2 pr-0">
            <label class="sg-form-field-label">Supplier Code</label>
          </div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input matInput type="text" formControlName="supplierCode">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-3 pt-2 pr-0">
            <label class="sg-form-field-label">Supplier Name</label>
          </div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input matInput type="text" formControlName="supplierName" >
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-3 pt-2 pr-0">
            <label class="sg-form-field-label">LN10 Code</label>
          </div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input matInput  type="text" formControlName="ln10Code" maxlength="9" appAlphaNumeric>
            </mat-form-field>
          </div>
        </div>      
        <div class="row">
          <div class="col-3 pt-2 pr-0">
            <label class="sg-form-field-label">LN55 Code</label>
          </div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input matInput type="text" formControlName="ln55Code" maxlength="9" appAlphaNumeric>
            </mat-form-field>
          </div>
        </div>                
        <div class="row">
          <div class="col-3 pt-2 pr-0">
            <label class="sg-form-field-label">Division</label>
          </div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input matInput  type="text" formControlName="division" >
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-3 pt-3 pr-0">
            <label class="sg-form-field-label">Assigned Supply Chain Users
              <span class="sg-form-field-required-marker ml-1">*</span>
            </label>
          </div>
          <div class="col-9 pt-2">
           <!-- <mat-form-field appearance="outline" class="w-100">
              <i><input matInput type="text" placeholder="Add User..."></i>
            </mat-form-field> -->
            <mat-form-field appearance="outline" class="example-chip-list">
              <mat-chip-list #chipList >
                <mat-chip
                  *ngFor="let slectedusers of allSelectedUsers; let i = index"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="remove(slectedusers, i)">
                  {{slectedusers.firstName + ' ' + slectedusers.lastName}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input
                type="text"
                  class="mat-autocomplete-trigger mat-chip-input mat-input-element ng-valid ng-touched ng-dirty"
                  placeholder="Add User..."
                  #addUserInput
                  formControlName="assignSupplyChain"
                  [matChipInputFor]="chipList"
                  [matAutocomplete]="autoUser"
                  (matChipInputTokenEnd)="add($event)">
              </mat-chip-list>
              <mat-autocomplete #autoUser="matAutocomplete" (optionSelected)="selected($event)">
                <mat-option *ngFor="let users of supplyChainUsers" [value]="users">
                  {{users.firstName + ' ' + users.lastName}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>      
          </div>
        </div>
        <div class="row" *ngIf="data.isEditUser">
          <div class="col-4 offset-3">
            <mat-checkbox formControlName="isActive" class="my-2">Is Active?</mat-checkbox>
          </div>
        </div>
      </form>
    </main>
    <div class="row mx-0 border-top p-3">
      <div class="col-6 pr-0 pl-1">
        <button mat-stroked-button class="mat-primary sg-primary-stroked"  matTooltip="Refresh Supplier Name"  matTooltipClass="custom-export-tooltip"
        matTooltipPosition="above" type="button"
          (click)="onRefreshClick()" *ngIf="data.isEditUser">Refresh</button>
      </div>
      <div class="col-6 p-0">
        <div class="d-flex justify-content-end" mat-dialog-action>
          <button mat-raised-button class="mat-primary rep-action-button rep-btn-margin mr-4"
           type="button"
          (click)="data.isEditUser ? onEditClick() : onAddClick()"
          [disabled]="isEdit ? enableButtonOnCrossClick ? (!supplierUserForm.dirty && supplierUserForm.valid) :
          ( supplierUserForm.invalid && enableButtonOnCrossClick) :
          supplierUserForm.invalid">Save</button>
          <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button" type="button"
          (click)="onCancelClick()">Cancel</button>
        </div>
      </div>
    </div>
  </section>
  <div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
    <mat-spinner></mat-spinner>
  </div>
  
  